import { render, staticRenderFns } from "./topBtn.vue?vue&type=template&id=9d168284&scoped=true&"
import script from "./topBtn.vue?vue&type=script&lang=js&"
export * from "./topBtn.vue?vue&type=script&lang=js&"
import style0 from "./topBtn.vue?vue&type=style&index=0&id=9d168284&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d168284",
  null
  
)

export default component.exports